import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { useTranslation } from "react-i18next";
import { z } from "zod";

const filterLinksSchema = z.object({
  strategy_from_id_equals: z.string().optional(),
});

export type FilterLinksSchema = z.infer<typeof filterLinksSchema>;

export function FilterLinks({ table_name }: { table_name: string }) {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: "strategy_from_id_equals",
      label: t(`${table_name}.searchbox.strategy_from_id_equals`, {
        defaultValue: "Strategy from (id)",
      }),
      type: "input",
    },
  ];

  return (
    <FilterTable
      columns={1}
      client="instit-quantilia"
      schema={filterLinksSchema}
      tableName="links"
      customBuildPath={() =>
        encodeURIComponent("qtl - dynamic data") + `/${table_name}`
      }
      fields={fields}
    />
  );
}
